import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
import App from './App.vue'
import router from './router'
import store from './store'
import VModal from 'vue-js-modal'
import VTooltip from 'v-tooltip'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTimes,
  faUndo,
  faShoppingCart,
  faCaretRight,
  faExclamationTriangle,
  faExclamationCircle,
  faCheckCircle,
  faPlus,
  faMinus,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faTimes,
  faUndo,
  faShoppingCart,
  faCaretRight,
  faExclamationTriangle,
  faExclamationCircle,
  faCheckCircle,
  faPlus,
  faMinus
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(VModal)
Vue.use(VTooltip)

// Custom icons
import IconPortrait from '@/components/icons/portrait'
import IconLandscape from '@/components/icons/landscape'
import IconRotate from '@/components/icons/rotate'
import IconZoomIn from '@/components/icons/zoom-in'
import IconZoomOut from '@/components/icons/zoom-out'
import IconCheck from '@/components/icons/check'
import IconInfo from '@/components/icons/info'
import IconLeft from '@/components/icons/left'
import IconRight from '@/components/icons/right'

Vue.component('icon-portrait', IconPortrait)
Vue.component('icon-landscape', IconLandscape)
Vue.component('icon-rotate', IconRotate)
Vue.component('icon-zoom-in', IconZoomIn)
Vue.component('icon-zoom-out', IconZoomOut)
Vue.component('icon-check', IconCheck)
Vue.component('icon-info', IconInfo)
Vue.component('icon-left', IconLeft)
Vue.component('icon-right', IconRight)

window.customizerVue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#fathead-customizer")
